import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/image/28.png';
import _imports_1 from '@/assets/image/34.png';
const _hoisted_1 = {
  class: "news"
};
const _hoisted_2 = {
  class: "list"
};
const _hoisted_3 = ["onClick"];
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const list = [{
      id: 1
    }];
    const currentPage = ref(1);
    const pageSize = ref(10);
    const total = ref(1); // 假设总条目数

    const handleCurrentChange = newPage => {
      currentPage.value = newPage;
      fetchData();
    };
    const fetchData = () => {};
    const toDes = id => {
      router.push(`/news/details/${id}`);
    };
    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_config_provider = _resolveComponent("el-config-provider");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "banner"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }), _createElementVNode("div", {
        class: "title"
      }, "热点资讯")], -1)), _createElementVNode("div", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
        return _createElementVNode("div", {
          onClick: $event => toDes(item.id),
          key: index,
          class: "box"
        }, [...(_cache[2] || (_cache[2] = [_createElementVNode("img", {
          src: _imports_1,
          alt: ""
        }, null, -1), _createElementVNode("div", {
          class: "title"
        }, "农产品“原产地直发”：加大投入完善产地建设，助力乡村振兴", -1), _createElementVNode("div", {
          class: "des"
        }, "8月25日，新电商平台信悦臻选宣布推出农产品“原产地直发”，将通过加大资金投入、直播扶持、人才培育、供应链优化等综合举措，进一步加大对优质水果、蔬菜、肉蛋等生鲜产品的8月25日，新电商平台信悦臻选宣布推出农产品“原产地直发”，将通过加大资金投入、直播扶持、人才培育、供应链优化等综合举措，进一步加大对优质水果、蔬菜、肉蛋等生鲜产品的", -1), _createElementVNode("div", {
          class: "btn"
        }, "查看全文", -1)]))], 8, _hoisted_3);
      }), 64)), _createVNode(_component_el_config_provider, {
        locale: _unref(zhCn)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_pagination, {
          "current-page": currentPage.value,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => currentPage.value = $event),
          "page-size": pageSize.value,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
          total: total.value,
          onCurrentChange: handleCurrentChange,
          class: "pagination",
          background: "",
          layout: "total, prev, pager, next"
        }, null, 8, ["current-page", "page-size", "total"])]),
        _: 1
      }, 8, ["locale"])])]);
    };
  }
};